var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 12.75l-.69-1.33L8.88.55a1 1 0 00-1.76 0L1.54 11.42l-.69 1.33A7.79 7.79 0 008 24a7.79 7.79 0 007.15-11.25",
    fill: "#02bd9c",
    fillRule: "evenodd",
    className: "svgdrop"
  })));
}
SvgDrop.displayName = 'Drop';
export default SvgDrop;